module.exports = __webpack_public_path__ + "img/9791186256923.c2f8db43.jpg";